export const ACCOUNT_MANAGEMENT_URL = process.env.REACT_APP_ACCOUNT_MANAGEMENT_URL || 'https://onboarding.chowreach.com';
export const STRIPE_PK='pk_live_JlUdLiiW335aBor3qFEjSj0F';


// WEBPACK FOOTER //
// ./src/config.js